import { InjectionToken } from '@angular/core';
import type { TinymceConfig } from './tinymce.interface';

export const TINYMCE_CONFIG = new InjectionToken<TinymceConfig>(
  'TinymceConfig',
);
